import { useAuth } from '@/auth/AuthProvider';

export function usePermissions() {
  const auth = useAuth();
  return {
    permissions: auth.permissions,
    hasPerm: auth.hasPerm,
    hasAll: (codenames: string[]) => codenames.every(auth.hasPerm),
    hasAny: (codenames: string[]) => codenames.some(auth.hasPerm),
  };
}
